import React, { useEffect } from "react";
import Succes_tick_gif from "../../Assests/imgs/new/Succes_tick_gif.gif";
import AffordableCarImg from "../../Assests/imgs/new/AffordableCarImg.png";
import Layout from "../Layout/Layout";
import { useNavigate } from "react-router-dom";
export default function ThankYou() {
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/rideshare-car-rentals");
    }, 10000);

    return () => clearTimeout(timer);
  }, [navigate]);
  return (
    <Layout>
      <div className="container-lg">
        <div className="success_div_conterr">
          <div className="succss_modal_div">
            {/* Left Image */}
            <div className="advetise_page_modal">
              <img src={AffordableCarImg} alt="Success" />
            </div>
            <div className="right_side_sucess_modl">
              {/* Title */}
              <h2 className="modal-title-custom">
                Thank You for Your Enquiry!
              </h2>
              <div className="advertise_sucessImg">
                <img src={Succes_tick_gif} alt="Success" />
              </div>
              {/* Content Section */}
              <div className="modal-content-section">
                {/* Left Content */}
                <div className="modal-left-content text-center">
                  <p className="success-message">
                    Our team has successfully received your details.
                  </p>
                  <p className="call-message" style={{ fontSize: "15px" }}>
                    You can expect a call from our experts within 24 hours to
                    help you book a car.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
